'use strict';

// eslint-disable-next-line no-unused-vars
/* globals define, $, window, ajaxify, socket */

define('chatCustoms', ['components', 'forum/chats/messages', 'chatFileUpload', 'emoji'], function (components, messages, chatFileUpload, emoji) {
	var ChatCustoms = {};

	var internals = {
		onReceivedChatMessage: null,
		lastAjaxifyRefreshTimestamp: null,
		prevPage: null,
	};

	ChatCustoms.init = function () {
		chatFileUpload.init();
		addScrollingToLastMessages();

		setTimeout(function () {
			ChatCustoms.scrollToLastMessage();
			chatFileUpload.showVideo();
			chatFileUpload.wrapImagesInLinks();
		}, 800);
	};

	// used by nodebb-plugin-emoji-custom plugin
	ChatCustoms.addEmojiButton = function (onClick) {
		var container = components.get('chat/composer');

		container.find('[data-action=add-emoji]').on('click', function (event) {
			var textarea = components.get('chat/input')[0];

			onClick(textarea, textarea.selectionStart, textarea.selectionEnd, event);
		});
	};

	// fix the problem with no refreshing chat on mobiles
	ChatCustoms.onChatLoaded = function () {
		$(window).on('action:chat.loaded', function () {
			ChatCustoms.init();
			emoji.addChatEmoji();
			// if (ajaxify.data.roomId && !/[0-9]+$/.test(ajaxify.currentPage)) {
			// 	ajaxify.currentPage += '/' + ajaxify.data.roomId;
			// }

			// currentPageShouldHaveUrlWithCurrentRoomId();

			// // prevent from multiple redirections on mobiles
			// if (ajaxify.currentPage === internals.prevPage && internals.lastAjaxifyRefresh !== null && ((new Date()).getTime() < internals.lastAjaxifyRefresh.getTime() + 3000)) {
			// 	return;
			// }

			// internals.prevPage = ajaxify.currentPage;
			// internals.lastAjaxifyRefresh = new Date();

			// ajaxify.refresh(function () {
			// 	setTimeout(function () {
			// 		components.get('chat/input').blur();
			// 		ChatCustoms.scrollToLastMessage();
			// 	}, 500);
			// });
		});
	};

	ChatCustoms.reloadChat = function () {
		currentPageShouldHaveUrlWithCurrentRoomId();

		ajaxify.refresh(function () {
			setTimeout(function () {
				components.get('chat/input').blur();
				ChatCustoms.scrollToLastMessage();
			}, 500);
		});
	};

	ChatCustoms.receivedChatMessage = function (data) {
		if (data.tpl_url !== 'chats' || internals.onReceivedChatMessage) {
			return;
		}

		socket.on('event:chats.receive', function (data) {
			$('[component="chat/recent/room"][data-roomid="' + data.roomId + '"] .teaser-content').html(data.message.cleanedContent);
		});

		internals.onReceivedChatMessage = true;
	};

	ChatCustoms.scrollToLastMessage = function () {
		messages.scrollToBottom($('.expanded-chat ul.chat-content'));

		if ($('.chat-content').length > 0) {
			$(window).on('videojs:player.ready', function () {
				messages.scrollToBottom($('.chat-content'));
			});
		}
	};

	function currentPageShouldHaveUrlWithCurrentRoomId() {
		if (!ajaxify.data.roomId) {
			return;
		}

		var roomIdRegex = /[0-9]+$/;

		ajaxify.currentPage = roomIdRegex.test(ajaxify.currentPage) ?
			ajaxify.currentPage.replace(roomIdRegex, ajaxify.data.roomId) :
			ajaxify.currentPage += '/' + ajaxify.data.roomId;
	}

	function addScrollingToLastMessages() {
		components.get('chat/input').on('focus', function () {
			ChatCustoms.scrollToLastMessage();
		});
	}

	return ChatCustoms;
});
